import { render } from "./MobileLayout.vue?vue&type=template&id=10f6db3d&scoped=true&ts=true"
import script from "./MobileLayout.vue?vue&type=script&lang=ts"
export * from "./MobileLayout.vue?vue&type=script&lang=ts"

import "./MobileLayout.vue?vue&type=style&index=0&id=10f6db3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f6db3d"]])

export default __exports__